import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { TRoles } from "../types/types";

export const useLoginFormVariant = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const loginVariantSearchParamURL = searchParams.get("variant");
  const [loginVariant, setLoginVariant] = useState<TRoles>(
    loginVariantSearchParamURL === "agent" ? "agent" : "client"
  );
  const handleLoginVariant = (mode: TRoles) => {
    setLoginVariant(mode);
    setSearchParams({ variant: mode }, { replace: true });
  };

  return { loginVariant, handleLoginVariant };
};
